import { getManager, ItemID, Page } from 'componentregistry';
import { Platform } from 'componentregistry/platform/Platform';
import { onIDUpdate } from 'layout/Sidebar/panels/PropertiesView/property-editors/PropertyEditorUtils';
import { camelCase } from 'lodash-es';
import { itemWithDefaultValues } from 'registry/Components';
import { isEmpty } from 'utils/isEmpty';

export function getShortenedId({
  platform,
  appUid,
  pageId,
  itemId,
  page,
}: {
  platform: Platform;
  appUid: string;
  pageId: string;
  page: Page;
  itemId: ItemID;
}): string {
  const item = page[itemId];
  const manager = getManager(item.type);
  let shortId = manager.generateShortId(item.props);

  if (isEmpty(shortId)) {
    const mgr = getManager(item.type);
    const ritem = itemWithDefaultValues(item);
    shortId = mgr.getDisplayText(ritem, true, {
      appUid,
      pageId,
      itemId,
      mgr,
      platform,
    });
    if (shortId) {
      shortId = shortId.replace(/[^a-zA-Z0-9 ]/g, '');
    }
  }

  shortId = camelCase((shortId ? `${shortId} ` : '') + manager.name);
  let newId = shortId;
  let counter = 0;
  while (page[newId]) {
    newId = `${shortId}${++counter}`;
  }
  return newId;
}

export function updateItemIDWithinPage(
  platform: Platform,
  page: Page,
  appUid: string,
  pageId: string,
  oldItemId: ItemID,
  newItemId: ItemID,
): Page {
  if (oldItemId === 'root' || newItemId === 'root') {
    console.warn('root is a reserved word for ItemID!');
    return page;
  }
  const itm = page[newItemId];
  if (itm) {
    console.warn(
      `Item of type ${itm.type} already exists with itemId: ${newItemId}!`,
    );
    return page;
  }
  const p = { ...page };
  const item = p[oldItemId];
  const parent = p[item.parent];
  const children = parent.children.map((c) =>
    c === oldItemId ? newItemId : c,
  );
  p[item.parent] = { ...parent, children };
  item.children.forEach((c) => {
    const child = p[c];
    p[c] = { ...child, parent: newItemId };
  });
  p[newItemId] = { ...item, itemId: newItemId };
  delete p[oldItemId];

  const itemIds = Object.keys(p);
  itemIds.forEach((itemId) => {
    const _item = p[itemId];
    if (!_item?.props) {
      console.warn(`Invalid item w/ id ${itemId}`, _item);
      return;
    }
    if (!_item.type) {
      console.warn(`Empty item ${itemId}`);
      return;
    }
    const mgr = getManager(_item.type);
    p[itemId] = onIDUpdate(
      platform,
      appUid,
      pageId,
      oldItemId,
      newItemId,
      _item,
      mgr,
    );
  });
  return p;
}
